"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Base64ToArrayBufferConverter = /** @class */ (function () {
    function Base64ToArrayBufferConverter() {
    }
    /**
     * Converts a base64 to an ArrayBuffer object
     * @returns {ArrayBufferLike}
     */
    Base64ToArrayBufferConverter.base64ToArrayBuffer = function (base64) {
        var binaryString = window.atob(base64);
        var len = binaryString.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes.buffer;
    };
    return Base64ToArrayBufferConverter;
}());
exports.Base64ToArrayBufferConverter = Base64ToArrayBufferConverter;
